import React from "react";
import { Star, Quote, ExternalLink } from "lucide-react";
import { BUSINESS } from "@/lib/api";

const REVIEWS = [
  {
    name: "Simar Sidhu",
    role: "Google Review",
    rating: 5,
    text: "Best HVAC company with amazing customer service. The team was professional, on-time and made the whole process easy from quote to install.",
    initial: "S",
    color: "#E50914",
  },
  {
    name: "Christy Livingstone",
    role: "Google Review",
    rating: 5,
    text: "We had our air conditioner installed by Corona Gas. We had good service, well mannered men install it. We have had no trouble & highly recommend the company.",
    initial: "C",
    color: "#0F0F0F",
  },
  {
    name: "Louise",
    role: "Google Review",
    rating: 5,
    text: "Thank you! Thank you! Thank you! To Dave and Corona Gas for diagnosing and repairing my HVAC system expediently after having 6 visits from a competitor to no avail. Well done!",
    initial: "L",
    color: "#E50914",
  },
  {
    name: "Monaco Estates",
    role: "Commercial Client",
    rating: 5,
    text: "Corona did the mechanical work for our town house site in Abbotsford. I would recommend them for your large multi-family projects!",
    initial: "M",
    color: "#475569",
  },
  {
    name: "Christoph Neuscheler",
    role: "Google Review",
    rating: 5,
    text: "Excellent service. Char and his team were very helpful and got things sorted quickly. Highly recommended!",
    initial: "CN",
    color: "#0F0F0F",
  },
  {
    name: "Kelly",
    role: "Homeowner",
    rating: 5,
    text: "Shawn was exceptionally friendly, knowledgeable and professional. My home is back to being toasty warm. Awesome job!",
    initial: "K",
    color: "#E50914",
  },
];

const Testimonials = () => {
  return (
    <section id="testimonials" className="relative py-20 lg:py-28 bg-white overflow-hidden" data-testid="testimonials-section">
      <div className="absolute right-0 -bottom-20 w-[500px] h-[500px] cg-halftone opacity-40 pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-4">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <div className="eyebrow justify-center inline-flex mb-4">Reviews</div>
          <h2 className="font-[Manrope] font-extrabold text-[#0F0F0F] text-3xl sm:text-4xl lg:text-5xl leading-tight mb-4">
            What Our Customers Say
          </h2>
          <p className="text-[#475569] text-lg">
            Real reviews from real customers. Read them all on Google.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {REVIEWS.map((r, i) => (
            <article
              key={i}
              className="bg-[#F7F7F7] rounded-2xl p-6 border border-transparent hover:border-[#E50914] hover:shadow-xl transition-all duration-300 relative"
              data-testid={`review-card-${i}`}
            >
              <Quote className="absolute top-4 right-4 w-10 h-10 text-[#E50914] opacity-15" />
              <div className="flex gap-0.5 mb-3">
                {Array.from({ length: 5 }).map((_, idx) => (
                  <Star
                    key={idx}
                    className={`w-4 h-4 ${idx < r.rating ? "fill-[#F4B400] text-[#F4B400]" : "text-[#E5E7EB]"}`}
                  />
                ))}
              </div>
              <p className="text-[#374151] leading-relaxed mb-5">"{r.text}"</p>
              <div className="flex items-center gap-3">
                <div
                  className="w-11 h-11 rounded-full flex items-center justify-center text-white font-bold font-[Manrope]"
                  style={{ background: r.color }}
                >
                  {r.initial}
                </div>
                <div>
                  <div className="font-[Manrope] font-bold text-[#0F0F0F]">{r.name}</div>
                  <div className="text-xs text-[#64748B]">{r.role}</div>
                </div>
              </div>
            </article>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-10">
          <a
            href={BUSINESS.googleReviewsUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-outline-coral"
            data-testid="see-all-google-reviews"
          >
            See all reviews on Google
            <ExternalLink className="w-4 h-4" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
